import { Button } from 'components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'components/ui/dialog';

import type { ReportView } from './api/reportViewTypes';

/** Confirmation step before soft-deleting an owned custom view. */
type DeleteReportViewModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    view: ReportView | null;
    isDeleting?: boolean;
    onConfirm: () => void;
};

export function DeleteReportViewModal({
    open,
    onOpenChange,
    view,
    isDeleting = false,
    onConfirm,
}: DeleteReportViewModalProps) {
    if (!view) {
        return null;
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="reports-light-overlay w-[calc(100%-2rem)] overflow-hidden sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Delete view</DialogTitle>
                    <DialogDescription>
                        Delete “{view.name}”? This can’t be undone. Anyone with a share link will
                        lose access.
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter className="min-w-0">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isDeleting}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="destructive"
                        disabled={isDeleting}
                        onClick={onConfirm}
                    >
                        {isDeleting ? 'Deleting...' : 'Delete view'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
